import * as React from 'react';
import { LazyLoadComponentWrapper } from '@components/lazy-load/lazy-load-component-wrapper';
import { PageLoadingIndicator } from '@components/page-loading-indicator';
import { IUnifiedTrackViewOwnProps } from './index';

const UnifiedTrackViewComponent = React.lazy(() => import(/* webpackChunkName:"im-unified-track-view" */'./index'));

export const UnifiedTrackView: React.FC<IUnifiedTrackViewOwnProps> = (props) => (
    <LazyLoadComponentWrapper
        fallback={<PageLoadingIndicator error={false} />}
        errorIndicator={<PageLoadingIndicator error={true} />}>
        <UnifiedTrackViewComponent {...props} />
    </LazyLoadComponentWrapper>
)
